import http from './http';

const tinycontentAPI = {
  get(name) {
    return http.get(`tinycontent/${name}/`)
    .then(
      function(success) { return success },
      function(error) { }
    )
  },
};


export default tinycontentAPI;

